/**
 * Default horizontal and vertical spacing for the entity map.
 */
export const DEFAULT_ENTITY_MAP_LAYOUT_SETTINGS = {
  horizontalSpaceBetweenNodes: 400,
  verticalSpaceBetweenNodes: 10,
};
